import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class StyleService {
    private headerStyling = new Subject<any>();
    private footerStyling = new Subject<any>();

    constructor(private readonly router: Router) {
        // Clear the alert message on route change.
        router.events.subscribe(event => {
            this.headerStyling.next({backgroundColor: "#000000"});
            this.footerStyling.next({backgroundColor: "#000000"});
        });
    }

    clear(): void {
        this.headerStyling.next();
    }

    getHeaderStyling(): Observable<any> {
        return this.headerStyling.asObservable();
    }

    getFooterStyling(): Observable<any> {
        return this.footerStyling.asObservable();
    }

    setHeaderStyling(headerBackgroundColor: string, headerFontColor: string, headerSecondaryFontColor: string): void {
        this.headerStyling.next({backgroundColor: headerBackgroundColor, fontColor: headerFontColor, secondaryFontColor: headerSecondaryFontColor});
    }

    setFooterStyling(footerBackgroundColor: string, footerFontColor: string): void {
        this.footerStyling.next({backgroundColor: footerBackgroundColor, fontColor: footerFontColor});
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/style.service.ts